/**
 * The wall's frost (plan 11 A3): a sheet behind the wall while this window
 * shows the Workspace. Never in compact or peek — focus from the wall steps
 * the Workspace aside there — and never on the web.
 */
import { isTauri } from "@/lib/is-tauri";
import { useWallVisibleHere } from "@/lib/wall-visibility";
import { useDesktopMode } from "@/stores/desktop-mode-store";

/** Whether this window shows the frost behind its wall. */
export function useWallFrostOn(): boolean {
  const denk = useDesktopMode((state) => state.mode === "denk");
  const wallVisible = useWallVisibleHere();
  return isTauri() && denk && wallVisible;
}
